// export const DATA_URL = '/ajax/regional.php';
export const DATA_URL = 'regional.json';